import { JSONContent } from '@tiptap/core'

export const richTextOptions = [
  'bold',
  'italic',
  'strike',
  'code',
  'kbd',
  'link',
  'highlight',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote',
  'codeBlock',
  'orderedList',
  'bulletList',
  'taskList',
  'image',
  'video',
  'table',
  'superscript',
  'subscript',
  'underline',
] as const

export const optionToNewOptions = (option: string) => {
  switch (option) {
    case 'strikethrough':
      return 'strike'
    case 'code block':
      return 'codeBlock'
    case 'bullet list':
      return 'bulletList'
    case 'ordered list':
      return 'orderedList'
    case 'paragraph':
      return 'paragraph'
    case 'task list':
      return 'taskList'
    default:
      if (richTextOptions.includes(option as RichTextOption)) {
        return option
      }
      throw new Error(`Unknown option: ${option}`)
  }
}

export type RichTextOption = (typeof richTextOptions)[number]

export const tiptapNodeToRichTextOption = (node: JSONContent) => {
  let nodeType = node.type as RichTextOption
  if (node.type === 'heading') {
    nodeType = `h${node.attrs?.level ?? 1}` as RichTextOption
  }

  const marks = node.marks?.map((mark) => mark.type) ?? []
  return [nodeType, ...marks] as RichTextOption[]
}

export function getAllowedFormatting(
  constraints:
    | {
        forbiddenNodes?: string[] | null | 'all'
        allowedNodes?: string[] | null
      }
    | undefined,
  allOptions = [...richTextOptions] as string[]
): string[] {
  if (constraints?.forbiddenNodes === 'all') {
    return []
  }

  if (constraints?.forbiddenNodes != null) {
    return allOptions.filter(
      (opt) => !constraints.forbiddenNodes!.includes(opt)
    )
  }

  if (constraints?.allowedNodes != null) {
    return constraints.allowedNodes
  }

  return [...allOptions]
}
